var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"user-select":"none"},style:(_vm.refreshable ? { cursor: 'pointer' } : {}),on:{"click":function($event){_vm.refreshable && _vm.refresh()}}},[_c('canvas',{ref:"canvas",attrs:{"id":"id-canvas","width":_vm.contentWidth,"height":_vm.contentHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }